import { render, staticRenderFns } from "./PlayerFormationWithCaptain.vue?vue&type=template&id=90fee882&scoped=true"
import script from "./PlayerFormationWithCaptain.vue?vue&type=script&lang=js"
export * from "./PlayerFormationWithCaptain.vue?vue&type=script&lang=js"
import style0 from "./PlayerFormationWithCaptain.vue?vue&type=style&index=0&id=90fee882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fee882",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VIcon,VSpacer})
